<script setup lang="ts">
import { Tag } from 'lucide-vue-next'
</script>

<template>
    <div class="relative mt-4 overflow-hidden rounded-[10px] p-px w-full">
        <div
            class="after:animate-rotate-rainbow after:from-primary absolute inset-0 after:absolute after:top-1/2 after:left-1/2 after:aspect-square after:min-h-[200%] after:min-w-[200%] after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-0 after:bg-conic after:to-[#111111] after:content-['']"
        ></div>
        <div class="relative isolate flex flex-col overflow-hidden rounded-[10px] bg-[#1F252B]">
            <div class="flex w-full items-center gap-3 px-6 py-2">
                <Tag class="text-primary min-w-6" />
                <h3 class="text-xs sm:text-sm">{{ $t('Exclusive discount for group purchases') }}</h3>
            </div>

            <div class="flex h-full w-full flex-col flex-wrap justify-between gap-4 bg-[#15191D] p-6 md:flex-row md:items-center">
                <div class="flex-1 space-y-2">
                    <h3 class="text-lg font-semibold">{{ $t('From 5 tickets') }}</h3>
                    <h2 class="flex items-center gap-2"><strong class="text-primary text-4xl font-semibold">10% </strong> {{ $t('discount') }}</h2>
                    <p class="text-sm">{{ $t('Discount automatically applied at checkout.') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
